import React, { Suspense, lazy } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
// Below-the-fold sections are code-split so the initial bundle stays tiny.
// Each chunk only downloads when the user scrolls toward it.
const HeroTestimonials = lazy(() => import('./components/HeroTestimonials').then(m => ({
  default: m.HeroTestimonials
})));
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const ProductSection = lazy(() => import('./components/ProductSection').then(m => ({
  default: m.ProductSection
})));
const TomosPrimaria = lazy(() => import('./components/TomosPrimaria').then(m => ({
  default: m.TomosPrimaria
})));
const TomosSecundaria = lazy(() => import('./components/TomosSecundaria').then(m => ({
  default: m.TomosSecundaria
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const Countdown = lazy(() => import('./components/Countdown').then(m => ({
  default: m.Countdown
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
// Defer popup until after main content paints — keeps initial load fast.
const SocialProofPopup = lazy(() => import('./components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
// Minimal skeleton fallback so the page doesn't jank as chunks stream in.
const SectionFallback = () => <div className="min-h-[200px]" aria-hidden="true" data-id="element-0" />;
export function App() {
  return <div className="bg-white text-gray-900 font-sans relative" data-id="element-1">
      <MetaPixel data-id="element-2" />
      {/* Above the fold — render eagerly for fastest LCP */}
      <TopBar data-id="element-3" />
      <Hero data-id="element-4" />
      <StatsBar data-id="element-5" />

      {/* Below the fold — streamed in as separate chunks */}
      <Suspense fallback={<SectionFallback data-id="element-7" />} data-id="element-6">
        <HeroTestimonials data-id="element-8" />
        <PainSection data-id="element-9" />
        <ProductSection data-id="element-10" />
        <TomosPrimaria data-id="element-11" />
        <TomosSecundaria data-id="element-12" />
        <BonusSection data-id="element-13" />
        <Countdown data-id="element-14" />
        <PricingSection data-id="element-15" />
        <Testimonials data-id="element-16" />
        <Guarantee data-id="element-17" />
        <FAQ data-id="element-18" />
        <Footer data-id="element-19" />
      </Suspense>

      <Suspense fallback={null} data-id="element-20">
        <SocialProofPopup data-id="element-21" />
      </Suspense>
    </div>;
}